import Vue from 'vue'
import AuthLayer from './layer'
import { IAM } from '@rhitics/core'

export interface AuthPluginOptions {
  user: IAM.User
  accessToken: string | null
}

export default function AuthPlugin(V: typeof Vue, options?: AuthPluginOptions) {
  const vm = new AuthLayer()

  const user = (options && options.user) || null
  const accessToken = (options && options.accessToken) || null

  vm.$set(vm, 'user', user)
  vm.$set(vm, 'accessToken', accessToken)

  V.prototype.$auth = vm
}
